/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      username
      name
      email
      phone
      timing
      address
      logo
      selectedTemplate
      description
      advancedseo
      isPaidUser
      paidWidgets
      paymentInfo
      userType
      nextBillingAt
      instagram
      x
      youtube
      facebook
      linkedin
      tiktok
      pintrest
      whatsapp
      reddit
      buymeacoffe
      googlemap
      calendly
      action
      widgets
      services
      gallery
      qna
      offer
      likesCount
      isDraft
      lastUpdatedField
      themeColor
      businessReviewInfo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      username
      name
      email
      phone
      timing
      address
      logo
      selectedTemplate
      description
      advancedseo
      isPaidUser
      paidWidgets
      paymentInfo
      userType
      nextBillingAt
      instagram
      x
      youtube
      facebook
      linkedin
      tiktok
      pintrest
      whatsapp
      reddit
      buymeacoffe
      googlemap
      calendly
      action
      widgets
      services
      gallery
      qna
      offer
      likesCount
      isDraft
      lastUpdatedField
      themeColor
      businessReviewInfo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      username
      name
      email
      phone
      timing
      address
      logo
      selectedTemplate
      description
      advancedseo
      isPaidUser
      paidWidgets
      paymentInfo
      userType
      nextBillingAt
      instagram
      x
      youtube
      facebook
      linkedin
      tiktok
      pintrest
      whatsapp
      reddit
      buymeacoffe
      googlemap
      calendly
      action
      widgets
      services
      gallery
      qna
      offer
      likesCount
      isDraft
      lastUpdatedField
      themeColor
      businessReviewInfo
      createdAt
      updatedAt
      __typename
    }
  }
`;
